var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20302 3.87291C9.57445 3.93481 9.82537 4.28611 9.76347 4.65754L7.94529 15.5666C7.88338 15.9381 7.53209 16.189 7.16065 16.1271C6.78922 16.0652 6.5383 15.7139 6.6002 15.3425L8.41839 4.43336C8.48029 4.06193 8.83158 3.811 9.20302 3.87291Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8392 3.87291C13.2107 3.93481 13.4616 4.28611 13.3997 4.65754L11.5815 15.5666C11.5196 15.9381 11.1683 16.189 10.7969 16.1271C10.4255 16.0652 10.1745 15.7139 10.2364 15.3425L12.0546 4.43336C12.1165 4.06193 12.4678 3.811 12.8392 3.87291Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77295 8.18182C4.77295 7.80526 5.07821 7.5 5.45477 7.5H15.4548C15.8313 7.5 16.1366 7.80526 16.1366 8.18182C16.1366 8.55838 15.8313 8.86364 15.4548 8.86364H5.45477C5.07821 8.86364 4.77295 8.55838 4.77295 8.18182Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.86377 11.8182C3.86377 11.4416 4.16903 11.1364 4.54559 11.1364H14.5456C14.9221 11.1364 15.2274 11.4416 15.2274 11.8182C15.2274 12.1947 14.9221 12.5 14.5456 12.5H4.54559C4.16903 12.5 3.86377 12.1947 3.86377 11.8182Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/hash.8041e388.svg";
export { ForwardRef as ReactComponent };